type ChatBubbleProps = {
  opened: boolean;
  loading: boolean;
  onClick: () => void;
};

export default function ChatBubble({ opened, loading, onClick }: ChatBubbleProps) {
  return (
    <button className="qk-chatbot-bubble" type="button" aria-label={opened ? "Fermer le chat" : "Ouvrir le chat"} onClick={onClick}>
      {loading ? (
        <span className="qk-chatbot-spinner" aria-hidden="true" />
      ) : opened ? (
        <span aria-hidden="true">&times;</span>
      ) : (
        <svg aria-hidden="true" viewBox="0 0 24 24" width="24" height="24">
          <path
            d="M4.5 11.2c0-4 3.4-7.2 7.5-7.2s7.5 3.2 7.5 7.2-3.4 7.2-7.5 7.2c-.8 0-1.6-.1-2.3-.4l-4 1.5 1.3-3.5a7 7 0 0 1-2.5-4.8Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path d="M8.5 11.5h.1M12 11.5h.1M15.5 11.5h.1" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      )}
    </button>
  );
}
